import React, { useState } from "react";
import { Dimensions, View, StyleSheet, Image, Platform } from "react-native";
import { Image as ImageCache } from "react-native-expo-image-cache";
import { Video, AVPlaybackStatus } from 'expo-av';
import { AntDesign, Entypo, Fontisto, Foundation,
         FontAwesome5, Octicons, MaterialCommunityIcons } from "@expo/vector-icons";

import Text from "./Text";
import colors from "../config/colors";
import textStyles from "../config/textStyles";


var windowWidth = Dimensions.get('window').width;
var windowHeight = Dimensions.get('window').height;
var textSmall = textStyles.textSmall
var textMedium =  textStyles.textMedium
var textLarge =  textStyles.textLarge
var sizeBrainComments = textStyles.sizeBrainComments
var sizeTree = textStyles.sizeTree




function CardListing({ 
                title, 
                seedDescription,
                subTitle, 
                type,
                imageUrl, 
                onPress, 
                onPressLike,
                onPressComment, 
                onPressNumLikes, 
                thumbnailUrl,
                commentsNum,
                actionsNum,
                onPressShare
                }) { 

const video =React.useRef(null);
const [status, setStatus] = useState({});
//alert(seedDescription)

  return (

      <View style={styles.card}>
            {/* <TouchableOpacity onPress={onPress}> */}

      <View style={styles.containerIcon}>
          {
            type === 0 ?
            <>
                 <View style={styles.iconOfAction0} >
                              <FontAwesome5  
                                                      
                                name={"seedling"} 
                                color={"#8DF78D"} 
                                size={20} 
                              />
                 </View>
                     <Text style={styles.actionName}> Semilla </Text>
             
                </>
         :
            type === 1 ?
            <>
                 <View  style={styles.iconOfAction1}  >
                              <AntDesign  
                                                  
                              name={"infocirlceo"} 
                              color={colors.chakra1nar} 
                              size={18} 
                              onPress={ onPress }
                              /> 
                  </View>
                     <Text style={styles.actionName}> Información </Text>
            </>
         :
            type === 2 ?
            <>
                  <View   style={styles.iconOfAction2} >
                              <MaterialCommunityIcons
                                                       
                                  name={"lightbulb-on-outline"} 
                                  color={colors.chakra2ama} 
                                  size={20}
                                  onPress={ onPress } 
                                />
                  </View>
                  <Text style={styles.actionName}> Idea </Text>                  
          </>
          :
            type === 3 ?
            <>
                 <View style={styles.iconOfAction3} >
                            <Fontisto  
                                                  
                                name={"map"} 
                                color={"green"} 
                                size={16} 
                                onPress={ onPress }
                              />
                 </View>
                    <Text style={styles.actionName}> Plan </Text>
               
            </>
          :
            type === 4 ?
            <>
                 <View  style={styles.iconOfAction4}>
                        
                            <FontAwesome5   
                                                 
                                name={"people-carry"}   //tractor people-carry
                                color={"blue"} 
                                size={15} 
                                onPress={ onPress }
                              />
                  </View>       
                    <Text style={styles.actionName}> Acción </Text>
              </>
          :
            type === 5 ?
            <>
                 <View style={styles.iconOfAction5}>
                            <Octicons 
                                                        
                                name={"megaphone"} 
                                color={colors.chakra5vlt} 
                                size={20} 
                                onPress={ onPress }
                              />
                  </View>
                  <Text style={styles.actionName}> Atraer personas </Text>
            </>  
          :
          type === 6 ?
          <>
               <View  style={styles.iconOfAction6}>
                            <FontAwesome5  
                                                      
                                name={"hat-wizard"} 
                                color={colors.chakra6rsa} 
                                size={18} 
                                onPress={ onPress }
                            /> 
                </View>
                  <Text style={styles.actionName}> Hacer divertida la semilla </Text>
         </>
          :
           type === 7 ?
           <>
               <View style={styles.iconOfAction7}>
                            <Fontisto                         
                            name={"sourcetree"} 
                            color={colors.chakra7ryo} 
                            size={18} 
                          /> 
                </View>
                  <Text style={styles.actionName}> Ramificar la semilla </Text>
            </> 
          :
          null
    }

    </View>

              <View>
              
              {  (Platform.OS === 'web') ?
                imageUrl.includes('.mp4') ?
                <Video 
                ref = {video}
                style = {styles.image}
                source = {{
                  uri: imageUrl
                }}
                useNativeControls
                resizeMode = "contain"
                isLooping
                onPlaybackStatusUpdate = {status => setStatus(() => status)}
                />
                :
                imageUrl.includes('.mov') ?
                <Video 
                ref = {video}
                style = {styles.image}
                source = {{
                  uri: imageUrl
                }}
                useNativeControls
                resizeMode = "contain"
                isLooping
                onPlaybackStatusUpdate = {status => setStatus(() => status)}
                />
                : 
                imageUrl.includes ('Poner ') ?
                <View style={styles.imageMountain} >
                            <Foundation //style={styles.imageMountain}
                                        name="mountains" 
                                        size={350} 
                                        color={colors.medium} />
                </View>
                :
                <View style={styles.imageView}>               
                    <Image
                      onPress={onPress}
                      style={styles.image}
                      tint="light"
                      preview={{ uri: thumbnailUrl }}
                      //uri={imageUrl}
                      source={{uri: imageUrl}}
                      resizeMode="contain"
                    />
                </View>
                :
                null
              }
              
              {  (Platform.OS === 'ios') ?
                imageUrl.includes('.mp4') ?
                <Video 
                ref = {video}
                style = {styles.image}
                source = {{
                  uri: imageUrl
                }}
                useNativeControls
                resizeMode = "contain"
                isLooping
                onPlaybackStatusUpdate = {status => setStatus(() => status)}
                />
                :
                imageUrl.includes('.mov') ?
                <Video 
                ref = {video}
                style = {styles.image}
                source = {{
                  uri: imageUrl
                }}
                useNativeControls
                resizeMode = "contain"
                isLooping
                onPlaybackStatusUpdate = {status => setStatus(() => status)}
                />
                : 
                imageUrl.includes ('Poner ') ?
                <View style={styles.imageMountain} >
                            <Foundation //style={styles.imageMountain}
                                        name="mountains" 
                                        size={350} 
                                        color={colors.medium} />
                </View>
                : 
                <View style={styles.imageView}>              
                    <ImageCache
                      onPress={onPress}
                      style={styles.image}
                      tint="light"
                      preview={{ uri: thumbnailUrl }}
                      uri={imageUrl}
                      resizeMode="contain"
                      //source={{uri: imageUrl}}
                    />
                </View>
                :
                null
              }
              </View>
            {/* </TouchableOpacity> */}
            <View style={styles.detailsContainer}>
                  <Text style={styles.title} numberOfLines={3}>
                    {title}
                  </Text>
                  <Text style={styles.seedDescription} numberOfLines={3}>
                    {seedDescription}
                  </Text>
                 <View style={styles.likeAndCommentNumbersContainer}> 
                        <Text style={styles.subTitle} // Número de cerebros like
                              numberOfLines={1} 
                              onPress={onPressNumLikes}>
                              {subTitle}
                        </Text>
                        <Text style={styles.commentsNum} // Número de comments
                              numberOfLines={1} >
                              {commentsNum}
                        </Text>
                        <Text style={styles.actionsNum} // Número de acciones(ramas)Tree
                              numberOfLines={1} >
                              {actionsNum}
                        </Text>
                  </View>
                  <View style={styles.likeAndCommentContainer}> 
                        <MaterialCommunityIcons style={styles.likes}
                                                name={"brain"} 
                                                color={colors.brain} 
                                                size={sizeBrainComments} 
                                                onPress={onPressLike}
                        />
                          <MaterialCommunityIcons style={styles.comments}
                                                  name={"comment-text-outline"} 
                                                  color={colors.commentsIcon} 
                                                  size={sizeBrainComments} 
                                                  onPress={onPressComment} 
                          /> 
                          <Entypo style={styles.actionSeed}
                                  name={"tree"}
                                  color={colors.commentsIcon} 
                                  size={sizeTree} 
                                  onPress={onPress}
                          />                
                  </View>
            </View>
      </View>

  );
}

const styles = StyleSheet.create({

  containerIcon: {
    //alignSelf: "flex-start", 
   // marginRight,
  //  marginTop: (windowWidth * .01),
   // backgroundColor: "red", 
    width: "100%",
    height: "10%",
  //  marginBottom: (windowHeight * -.012),
   // zIndex: 1,
    flexDirection: "row"
    },
viewIconAndNameAction: {
    flexDirection: "row",
    alignSelf: "flex-start", 
    //backgroundColor: "blue", 
    alignItems: "center",
    marginLeft: "3.5%",
  },
  actionName: {
    fontSize: textSmall,
    color: colors.textGeneral,
    marginTop: "2%",
    //textAlignVertical: "bottom",
    marginRight: "1.5%",
  },
  iconOfAction0: { 
    flexDirection: "row",
    height:35 ,   
    width:35,  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: "#8DF78D",    
    alignItems: "center", 
    justifyContent: "center",
    marginBottom: "-1.2%", 
    zIndex: 2,
   // alignSelf: "flex-end",
    marginLeft: "2%", 
    marginRight: "2%", 
   marginTop: '1.5%',
    backgroundColor: colors.fondoImagenes 
    },
  iconOfAction1: { 
    flexDirection: "row",
    height: 35,   
    width: 35,  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra1nar,    
    alignItems: "center", 
    justifyContent: "center",
    //marginBottom: "-1.2%", 
    zIndex: 1,
    alignSelf: "flex-end", 
    marginLeft: "2%", 
    marginRight: "2%", 
   // marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },
  iconOfAction2: { 
    flexDirection: "row",
    height: 35,   
    width: 35,  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra2ama,    
    alignItems: "center", 
    justifyContent: "center",
   // marginBottom: "-1.2%", 
    zIndex: 2,
    alignSelf: "flex-end", 
    marginLeft: "2%", 
    marginRight: "2%", 
    marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },
iconOfAction3: { 
    flexDirection: "row",
    height: 35,   
    width: 35,  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra3ver,    
    alignItems: "center", 
    justifyContent: "center",
    //marginBottom: "-1.2%", 
    zIndex: 2,
    alignSelf: "flex-end", 
    marginLeft: "2%", 
    marginRight: "2%", 
    marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },
iconOfAction4: { 
    flexDirection: "row",
    height: 35,   
    width: 35,  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: "blue",    
    alignItems: "center", 
    justifyContent: "center",
   // marginBottom: "-1.2%", 
    zIndex: 2,
    alignSelf: "flex-end", 
    marginLeft: "2%", 
    marginRight: "2%", 
  //  marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },
iconOfAction5: { 
    flexDirection: "row",
    height: 35,   
    width: 35,  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra5vlt,    
    alignItems: "center", 
    justifyContent: "center",
    //marginBottom: "-1.2%", 
    zIndex: 2,
    alignSelf: "flex-end", 
    marginLeft: "2%", 
    marginRight: "2%", 
   // marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },
iconOfAction6: { 
    flexDirection: "row",
    height:35,   
    width: 35,  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra6rsa,    
    alignItems: "center", 
    justifyContent: "center",
   // marginBottom: "-1.2%", 
    zIndex: 2,
    alignSelf: "flex-end", 
    marginLeft: "2%", 
    marginRight: "2%", 
   // marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },
iconOfAction7: { 
    flexDirection: "row",
    height: 35,   
    width: 35,  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra7ryo,    
    alignItems: "center", 
    justifyContent: "center",
  //  marginBottom: "-1.2%", 
    zIndex: 2,
    alignSelf: "flex-end", 
    marginLeft: "2%", 
    marginRight: "2%", 
    //marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },
  iconOfAction8: { 
    flexDirection: "row",
    height: 35,   
    width: 35,  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra9aur,    
    alignItems: "center", 
    justifyContent: "center",
    //marginBottom: "-1.2%", 
    zIndex: 2,
    alignSelf: "flex-end", 
    marginLeft: "2%", 
    marginRight: "2%", 
    //marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },
  card: {
    borderRadius: 15,
    backgroundColor: colors.fondoGeneral,
    marginBottom: 15,
    overflow: "hidden",
    width:'94%',
    alignSelf:'center',
  },
  detailsContainer: {
   // padding: 20,
  },
  image: {
    //marginTop: (windowHeight * .015),
    width: "100%",
    height: 250, //(windowHeight * .343), //250,
    //borderRadius: 15,
    alignItems: "center", 
    backgroundColor: colors.fondoGeneral
  },
  // imageView: {       // Css para el image del support y este actua en conjunto con viewImageSupport
  //  // width:  (windowWidth), //400,  
  //  // height: 250, //(windowWidth* .343),  
  //   backgroundColor: "black",  //colors.chakra8tur,
  //   alignItems: "center", 
  // },
  imageMountain: {
    width: "100%",
    height: 250,
    alignItems: "center"
  },
  likeAndCommentContainer: {
     flexDirection: "row",
     width: "100%",
     height: 50,
     marginTop: "2%",
  },
  likeAndCommentNumbersContainer: {
    flexDirection: "row",
    width: "100%",
    height: 40,
    marginTop: "3%",
 },
  likes: {
    fontSize: textSmall,
    marginLeft: "3.5%",
    //color: colors.medium
 },
  actionsNum:{
  fontSize: textSmall,
  marginLeft: "38%",
  color: colors.medium
 },
 commentsNum:{
  fontSize: textSmall,
  marginLeft: "39%",
  color: colors.medium
 },

  subTitle: {
    fontSize: textSmall,
    color: colors.medium,
    marginLeft: "4%"
  },
  title: {
    alignSelf: "center",
    fontSize: textSmall,
    fontWeight: textStyles.fontWeightMedium,
    color: colors.textGeneral,
    marginBottom: 2,
  },
  seedDescription: {
    alignSelf: "center",
    marginTop:5,
    fontSize: textSmall,
    //fontWeight: colors.fontWeightMedium,
    color: colors.textGeneral,
    marginBottom: 2,
  },
  comments:{
  //  fontSize: 18,
    marginLeft: "36.5%",
   // color: colors.medium,
  
   },
  actionSeed:{
   // fontSize: 18,
    marginLeft: "37%",
    //color: colors.textGeneral,
   },
   tree:{
  //  fontSize: 18,
    marginLeft: "40%",
    //color: colors.textGeneral,
   },
});

export default CardListing;
